/**
 * Renders "Who can see what" into Users & Roles (Ed, 2026-09-24). The table
 * itself is computed in view-access.ts from the planner's own gates; this
 * only turns it into HTML. Closed by default: it answers a question, it
 * isn't what the page is for.
 */
import { roleName } from "./access-labels";
import { ROLE_ORDER, viewAccessMatrix } from "./view-access";

function esc(s: string): string {
  return s.replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c] as string);
}

export function viewAccessHtml(): string {
  const rows = viewAccessMatrix();
  return `<summary>Who can see what</summary>
    <div class="view-access-body">
      <p>Which roles see each part of the planner. Worked out from the planner's
        own rules, so it always matches what they can open. Each view's data is
        also checked again on the server.</p>
      <table>
        <thead><tr><th>View</th>${ROLE_ORDER.map((r) => `<th>${esc(roleName(r))}</th>`).join("")}</tr></thead>
        <tbody>${rows.map((row) => `<tr>
          <td>${esc(row.view)}<span class="va-about">${esc(row.about)}</span></td>
          ${ROLE_ORDER.map((r) => row.roles[r]
            ? `<td class="va-yes" aria-label="${esc(roleName(r))} can see ${esc(row.view)}">✓</td>`
            : `<td class="va-no" aria-label="${esc(roleName(r))} cannot see ${esc(row.view)}">—</td>`).join("")}
        </tr>`).join("")}</tbody>
      </table>
    </div>`;
}

/** Fill the disclosure once; the table depends on code, not on data. */
export function renderViewAccess(): void {
  const el = document.getElementById("viewAccess");
  if (el && !el.hasChildNodes()) el.innerHTML = viewAccessHtml();
}
